// IMPORTANT: Please note that you have to copy and paste
// this file to production manually because this file will not get uploaded to Shopify prod.

// CODE for Runway Collections Dropdown in the Header
const collection_category = 'Runway'.toLowerCase();
const projects_url = '/pages/project-list?cat=' + collection_category;

async function fetchProducts(url, category) {
  const response = await fetch(url);
  const html = await response.text();
  // Convert the HTML string into a document object
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  let projectList = doc.querySelector('#allProjectCategories');
  projectList = JSON.parse(projectList.value);
  const filterProjectList = projectList.filter((project) => project.category.toLowerCase() === category);
  const list = filterProjectList
    .map((project) => `<li class="nav-link"><a href=${project.url}>${project.title}</a></li>`)
    .join('');
  document.querySelector('ul.nav-link__dropdown').innerHTML = list;
}
if (collection_category && document.querySelector('ul.nav-link__dropdown')) {
  fetchProducts(projects_url, collection_category);
}

// Code for Subscription Form in the Footer
function subscriptionSubmit(event) {
  event.preventDefault();
  const email = document.getElementById('k_id_email').value;
  const settings = {
    async: true,
    crossDomain: true,
    url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
    method: 'POST',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'cache-control': 'no-cache',
    },
    data: {
      g: 'XrMt3c',
      $fields: 'email',
      email: email,
      $source: 'Custom Forms',
    },
  };

  $.ajax(settings).done(function (response) {
    if (response.data.is_subscribed) {
      document.getElementById('k_id_email').value = '';
      document.getElementById('form-response').textContent =
        'Thank you for signing up. We look forward to share our journey with you.';
      setTimeout(() => (document.getElementById('form-response').textContent = ''), 10000);
    }
  });
}

window.addEventListener('DOMContentLoaded', function () {
  const frontpageCollectionSections = document.querySelectorAll('.js-collectionImages');
  const fullWidthImageSections = document.querySelectorAll('.js-fullWidthImage');
  const imageWithTextSections = document.querySelectorAll('.js-imageWithText');

  if (frontpageCollectionSections?.length > 0) initFrontpageCollectionSections(frontpageCollectionSections);
  if (fullWidthImageSections?.length > 0) initFullWidthImageSections(fullWidthImageSections);
  if (imageWithTextSections?.length > 0) initImageWithTextSections(imageWithTextSections);

  if (window.location.pathname.includes('/account/login')) {
    showCorrectForm();

    // Show "email already exists" message if redirected from register
    const emailAlreadyExists = document.querySelector('[data-email-already-exists]');
    const initialStep = sessionStorage.getItem('initialStep');
    if (initialStep === 'register' && emailAlreadyExists) {
      emailAlreadyExists.classList.remove('customer__message--hidden');
      sessionStorage.removeItem('initialStep');
    }
  }

  if (window.location.pathname.includes('/account/register')) {
    // Redirect logged-in customers away from the register page
    const registerContainer = document.querySelector('[data-customer-logged-in]');
    if (registerContainer) {
      if (sessionStorage.getItem('returnToCheckout')) {
        sessionStorage.removeItem('returnToCheckout');
        window.location.replace('/cart');
      } else {
        window.location.replace('/account');
      }
      return;
    }

    sessionStorage.setItem('initialStep', 'register');

    // Store form errors from Liquid data attribute
    const formErrorsEl = document.querySelector('[data-form-errors]');
    if (formErrorsEl) {
      sessionStorage.setItem('formErrors', formErrorsEl.dataset.formErrors);
    }
  }

  // check if the announcement bar should be shown based on the session storage
  const announcementBar = document.querySelector('.announcement-bar');
  if (sessionStorage.getItem('announcementBarClosed')) {
    announcementBar.style.display = 'none';
  }
});

function hideAnnouncementBar() {
  const announcementBar = document.querySelector('.announcement-bar');
  announcementBar.style.display = 'none';
  sessionStorage.setItem('announcementBarClosed', 'true');
}

function initFrontpageCollectionSections(sections) {
  sections.forEach((section) => {
    const sectionId = section.dataset.sectionId;
    const imageWrap = document.getElementById(sectionId);
    const verticalImgs = imageWrap?.querySelectorAll('.image-wrapper--vertical');
    const horizontalImgs = imageWrap?.querySelectorAll('.image-wrapper--horizontal');

    if (verticalImgs?.length > 1 || horizontalImgs?.length > 1) {
      const intervalTime = Number(imageWrap?.getAttribute('data-interval')) || 2500;
      const alternateTransition = imageWrap?.getAttribute('data-alternate') === 'true';

      let currentVertical = 1;
      let currentHorizontal = 1;
      let lastVertical = false;
      let lastHorizontal = false;

      if (verticalImgs?.length > 1) {
        setInterval(() => {
          verticalImgs.forEach((img) => {
            const dataIndex = img.getAttribute('data-index');
            const dataLastItem = img.getAttribute('data-last-item') !== null;
            if (currentVertical === Number(dataIndex)) {
              img.classList.add('active');
              img.classList.remove('inactive');
              lastVertical = dataLastItem;
            } else {
              img.classList.remove('active');
              img.classList.add('inactive');
            }
          });
          currentVertical = lastVertical ? 0 : currentVertical + 1;
        }, intervalTime);
      }

      if (horizontalImgs?.length > 1) {
        setTimeout(
          () => {
            setInterval(() => {
              horizontalImgs.forEach((img) => {
                const dataIndex = img.getAttribute('data-index');
                const dataLastItem = img.getAttribute('data-last-item') !== null;
                if (currentHorizontal === Number(dataIndex)) {
                  img.classList.add('active');
                  img.classList.remove('inactive');
                  lastHorizontal = dataLastItem;
                } else {
                  img.classList.remove('active');
                  img.classList.add('inactive');
                }
              });
              currentHorizontal = lastHorizontal ? 0 : currentHorizontal + 1;
            }, intervalTime);
          },
          alternateTransition ? intervalTime / 2 : 0,
        );
      }
    }
  });
}

function initFullWidthImageSections(sections) {
  sections.forEach((section) => {
    const sectionId = section.dataset.sectionId;

    let fullWidthImageOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.25,
    };

    let fullWidthImageOptionsCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          document.querySelector('.header .inner-container').classList.add('header-white');
          document.querySelector('.announcement-bar').classList.add('header-white');
        } else {
          document.querySelector('.header .inner-container').classList.remove('header-white');
          document.querySelector('.announcement-bar').classList.remove('header-white');
        }
      });
    };

    let fullWidthImageObserver = new IntersectionObserver(fullWidthImageOptionsCallback, fullWidthImageOptions);

    if (section) {
      fullWidthImageObserver.observe(section);
    }

    const imageWrap = document.getElementById(sectionId);
    const fullWidthImages = imageWrap?.querySelectorAll('.image-wrapper--full-width');

    if (fullWidthImages?.length > 1) {
      const intervalTime = Number(imageWrap?.getAttribute('data-interval')) || 2500;

      let currentImg = 1;
      let lastImg = false;

      setInterval(() => {
        fullWidthImages.forEach((img) => {
          const dataIndex = img.getAttribute('data-index');
          const dataLastItem = img.getAttribute('data-last-item') !== null;
          if (currentImg === Number(dataIndex)) {
            img.classList.add('active');
            img.classList.remove('inactive');
            lastImg = dataLastItem;
          } else {
            img.classList.remove('active');
            img.classList.add('inactive');
          }
        });
        currentImg = lastImg ? 0 : currentImg + 1;
      }, intervalTime);
    }
  });
}

function initImageWithTextSections(sections) {
  sections.forEach((section) => {
    const sectionId = section.dataset.sectionId;
    const imageWrap = document.getElementById(sectionId);
    const fullWidthImages = imageWrap?.querySelectorAll('.image-wrapper--image-with-text');

    const productLinks = imageWrap?.querySelectorAll('.js-productLink');

    if (fullWidthImages?.length > 1) {
      const intervalTime = Number(imageWrap?.getAttribute('data-interval')) || 2500;

      let currentImg = 1;
      let lastImg = false;

      setInterval(() => {
        fullWidthImages.forEach((img) => {
          const dataIndex = img.getAttribute('data-index');
          const dataLastItem = img.getAttribute('data-last-item') !== null;

          if (currentImg === Number(dataIndex)) {
            img.classList.add('active');
            img.classList.remove('inactive');
            lastImg = dataLastItem;
          } else {
            img.classList.remove('active');
            img.classList.add('inactive');
          }
        });

        productLinks.forEach((link) => {
          link.classList.remove('product-link--active');
        });
        productLinks[currentImg].classList.add('product-link--active');

        currentImg = lastImg ? 0 : currentImg + 1;
      }, intervalTime);
    }
  });
}

// Code for Customer sections
function showCorrectForm(formType) {
  const loginForm = document.querySelector('#login');
  const recoverForm = document.querySelector('#recover');

  if ((window.location.href.includes('recover') || formType === 'recover') && formType !== 'login') {
    loginForm.style.display = 'none';
    recoverForm.style.display = 'flex';
  } else {
    loginForm.style.display = 'flex';
    recoverForm.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  // Only run on /account/register
  if (window.location.pathname.includes('/account/register')) {
    const dobField = document.getElementById('RegisterForm-dob');
    const dobLabel = document.querySelector('label[for="RegisterForm-dob"]');

    if (dobField && dobLabel) {
      dobField.addEventListener('focus', function () {
        dobLabel.style.display = 'none';
      });

      dobField.addEventListener('blur', function () {
        if (dobField.value === '') {
          dobLabel.style.display = 'block';
        }
      });
    }
  }
});

// code to process the create customer form
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('create-customer-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault(); // take control

    // 1) Build tags
    const gender = form.querySelector('#RegisterForm-gender')?.value?.trim();
    const country = form.querySelector('#RegisterForm-country')?.value?.trim();
    const dateOfBirth = form.querySelector('#RegisterForm-dob')?.value?.trim();
    const termsAndConditions = form.querySelector('#RegisterForm-terms-and-conditions')?.checked;
    const consentToMarketing = form.querySelector('#RegisterForm-consent-to-marketing')?.checked;
    const tags = [];
    if (gender) tags.push(`gender:${gender}`);
    if (country) tags.push(`country:${country}`);
    if (dateOfBirth) tags.push(`date_of_birth:${dateOfBirth}`);
    if (consentToMarketing) tags.push(`consent_to_marketing:true`);
    const tagsEl = form.querySelector('#RegisterForm-tags');
    if (tagsEl) tagsEl.value = tags.join(',');

    // Sync Shopify's accepts_marketing hidden field with the consent checkbox
    const acceptsMarketingEl = form.querySelector('#RegisterForm-accepts-marketing');
    if (acceptsMarketingEl) acceptsMarketingEl.value = consentToMarketing ? 'true' : 'false';

    // 2) Custom validation (example)
    const email = form.querySelector('input[name="customer[email]"]')?.value?.trim();
    const password = form.querySelector('input[name="customer[password]"]')?.value;
    const errors = [];
    if (!email) errors.push('Email is required');
    if (!password || password.length < 6) errors.push('Password must be at least 6 characters');
    if (dateOfBirth && dateOfBirth > new Date().toISOString().split('T')[0]) errors.push('Date of birth must be in the past');
    if (errors.length) {
      // show your UI error messages here
      alert(errors.join('\n'));
      return;
    }

    // 3) Disable button / show loading (optional)
    const submitBtn = form.querySelector('#RegisterSubmit');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
    }

    // 4) Submit to Shopify
    // Use requestSubmit() to trigger built-in validation (if novalidate is removed)
    // or form.submit() to bypass it. You currently use novalidate, so:
    form.submit();
  });
});
document.addEventListener('DOMContentLoaded', checkFaqContent);
document.addEventListener('DOMContentLoaded', accordionCheck);

function checkFaqContent() {
  const faqContent = document.querySelector('[data-faq-content]');
  if (faqContent) {
    const allH2 = faqContent.querySelectorAll('h2');
    allH2.forEach((h2) => {
      h2.classList.add('article__question');
      h2.addEventListener('click', () => {
        h2.classList.toggle('article__question--active');
        const panel = h2.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
    const allUl = faqContent.querySelectorAll('h2+ul');
    allUl.forEach((ul) => {
      ul.classList.add('article__answer');
    });
    faqContent.style.visibility = 'visible';
  }
}

function accordionCheck() {
  document.querySelectorAll('.article').forEach((article) => {
    const input = article.querySelector('input[type="radio"]');
    const panel = article.querySelector(':scope > div'); // the div after the label

    const close = (el) => {
      el.style.maxHeight = '0px';
    };
    const open = (el) => {
      el.style.maxHeight = el.scrollHeight + 'px';
    };

    if (input) {
      // initial state
      if (!input.checked) {
        panel.style.overflow = 'hidden';
        panel.style.transition = 'max-height .35s ease';
        close(panel);
      }

      input.addEventListener('change', () => {
        // close all
        document.querySelectorAll('.article > div').forEach(close);
        // open the one that was checked
        if (input.checked) open(panel);
      });
    }

    // recalc on content changes (images/fonts) if needed
    window.addEventListener('resize', () => {
      if (input && input.checked) open(panel);
    });
  });
}
